module.exports = __webpack_public_path__ + "static/media/dualMsgActive.b7e9811c.svg";